// Security-focused constants to avoid magic numbers
export const VALIDATION_LIMITS = {
  POSTAL_CODE: { LENGTH_1: 3, LENGTH_2: 4 },
  REPRESENTATIVES: { MAX_COUNT: 10 },
} as const;
